import axios from 'axios';

const Prevmet = axios.create({ baseURL: 'https://apiprevmet3.inmet.gov.br' });

export default Prevmet;
